const KLEVU_OPTIONS = {
  url: {
    landing: globalThis.KlevuLanding,
    protocol: 'https:',
    search: 'https://eucs32v2.ksearchnet.com/cs/v2/search',
    queryParam: 'q',
  },
  search: {
    minChars: 0,
    searchBoxSelector: '#klevu-search',
    apiKey: globalThis.KlevuApiKey,
    infiniteScrollOffsetLanding: 1500,
  },
  analytics: {
    apiKey: globalThis.KlevuApiKey,
  },
  theme: {
    setTemplates: [
      {
        scope: 'landing,catnav',
        selector: '#cyberCustom_klevuSortBy',
        name: 'sortBy',
      },
      {
        scope: 'landing',
        selector: '#cyberCustom_productBlock',
        name: 'productBlock',
      },
      {
        scope: 'landing',
        selector: '#cyberCustom_results',
        name: 'results',
      },
      {
        scope: 'landing',
        selector: '#cyberCustom_klevuLandingTemplateTabResults',
        name: 'tab-results',
      },
      {
        scope: 'quick',
        selector: '#cyberCustom_quickProductBlock',
        name: 'klevuQuickProductBlock',
      },
      {
        scope: 'landing',
        selector: '#cyberCustom_landingTemplateContentBlock',
        name: 'contentBlock',
      },
    ],
    modules: {
      resultInfiniteScroll: {
        quickSearch: {
          enable: true,
        },
        searchResultsPage: {
          enable: true,
        },
        categoryPage: {
          enable: true,
        },
      },
    },
  },
};

if (globalThis.KlevuEnabled) {
  klevu(KLEVU_OPTIONS);

  klevu({
    theme: {
      setHelpers: {
        'landing,catnav': {
          cyberCustomSortBy: function (dataLocal) {
            var klevuStorage = klevu.getSetting(
              klevu.settings,
              'settings.storage'
            );
            switch (
              klevuStorage.sort.getElement(dataLocal) == dataLocal
                ? 'RELEVANCE'
                : klevuStorage.sort.getElement(dataLocal)
            ) {
              case 'RELEVANCE':
                return 'Relevans';
              case 'PRICE_ASC':
                return 'Pris: Lägst först';
              case 'PRICE_DESC':
                return 'Pris: Högst först';
              case 'NEW_ARRIVAL_DESC':
                return 'Nyast först';
              default:
                return 'Relevans';
            }
          },
        },
      },
    },
  });
}
